document.addEventListener('DOMContentLoaded', () => {
    class SubscriptionWidget extends HTMLElement {
        constructor() {
            super();

            this.firstVariant = JSON.parse(this.querySelector("script[data-variant]").textContent);
            this.currentVariant = this.firstVariant;

            this.selectors = {
                planPrice: this.querySelector(".price-label--plan"),
                onePrice: this.querySelector(".price-label--one"),
                savePrice: this.querySelector(".subscription-radio--badge"),
                selectorWrapper: this.querySelector(".subscription-template__selector"),
                form: document.querySelector(".product .product-form__buy-buttons form")
            }

            this.inputs = this.querySelectorAll('.subscription-radio__input');

            this.configs = new Map(
                [...this.querySelectorAll("script:not([data-variant])")].map(script => {
                    const id = script.getAttribute("id").replace("config-", "")
                    const content = JSON.parse(script.textContent);
                    return [id, content]
                }));

            this.templates = new Map(
                [...this.querySelectorAll("template")].map(template => {
                    const id = template.getAttribute("id").replace("select-", "")
                    return [id, template]
                }));

            this.handleChange = this.onChange.bind(this);
        }

        connectedCallback() {
            this.inputs.forEach(input => input.addEventListener("change", () => {
                this.disabledSelector();
                this.updateFormId(this.currentVariant);
            }))

            document.addEventListener('variant:changed', (event) => {
                this.currentVariant = event.detail.variant;
                this.refreshContent(event.detail.variant, true);
                this.updateFormId(event.detail.variant);
            });

            this.querySelector("select").addEventListener("change", this.handleChange);


        }

        refreshContent(variant, refreshSelector) {
            const { id, price } = variant;

            const { selling_plan_allocations } = this.configs.get(String(id));
            if (refreshSelector == true) {
                const currentTemplate = this.templates.get(String(id));
                this.updateSelector(currentTemplate);
            }
            const currentPlan = [...selling_plan_allocations].find(({ selling_plan_id }) => selling_plan_id == this.helper().getCurrentPlanId());

            console.log(currentPlan.price, currentPlan.compare_at_price);

            const saveAmount = this.helper().getPercentage(Number(currentPlan.compare_at_price), Number(currentPlan.price));
            this.updatePrices(price, currentPlan.price, saveAmount);
            this.disabledSelector();
        }

        updateSelector(newTemplate) {
            const { selectorWrapper } = this.selectors;
            const currrentSelector = selectorWrapper.querySelector("select");
            const { children } = newTemplate.content.cloneNode(true);
            this.querySelector("select").removeEventListener("change", this.handleChange)
            currrentSelector.replaceWith(children[0]);
            this.querySelector("select").addEventListener("change", this.handleChange)
        }

        updatePrices(originPrice, comparePrice, saveAmount) {
            const { planPrice, onePrice, savePrice } = this.selectors;
            if (onePrice) onePrice.textContent = shopifyFormatMoney(originPrice);
            if (planPrice) planPrice.textContent = shopifyFormatMoney(comparePrice);
            if (savePrice) savePrice.textContent = `- ${saveAmount}%`
        }

        updateFormId(variant) {
            const isSubscribed = this.helper().isSubsribe();
            const { id } = variant;
            const { id: sellingVariantId } = this.configs.get(String(id));
            const formId = this.selectors.form.querySelector("input[name='id']");
            if (formId) formId.value = isSubscribed ? sellingVariantId : id;
        }

        disabledSelector() {
            const { selectorWrapper, form } = this.selectors;
            const isSubscribed = this.helper().isSubsribe();
            const select = this.querySelector("select");
            const inputSellingPlan = form.querySelector("input[name='selling_plan']")

            if (!select && !selectorWrapper) return;

            selectorWrapper.toggleAttribute("hidden", !isSubscribed);

            select.toggleAttribute("disabled", !isSubscribed);
            if (inputSellingPlan) {
                inputSellingPlan.toggleAttribute("disabled", isSubscribed);
            }
        }

        onChange(event) {
            this.refreshContent(this.currentVariant, false);
            event.target.value = this.helper().getCurrentPlanId();
        }

        helper() {
            return {
                isSubsribe: () => !![...this.inputs].find(input => input.classList.contains("subscription-radio__input--plan") && input.checked),
                getPercentage: (comparePrice, price) => (((comparePrice - price) * 100 / comparePrice) ).toFixed(0),
                getCurrentPlanId: () => this.querySelector("select").value
            }
        }


    }

    window.customElements.define("subscription-widget", SubscriptionWidget);
});